import AlertMessage from "./AlertMessage"

export default function NoResultsFound() {
  return(
    <div className="flex flex-col items-center w-full lg:h-full px-3 mt-4 bg-grey-900 rounded-b">
      <AlertMessage message="No Results Found" />
    </div>
  )
}